// Shared constants for project management

export const PROJECT_STATUS_OPTIONS = [
  { value: "active", label: "Open" },
  { value: "closed", label: "Closed" },
];

export type ProjectStatus = "active" | "closed";

// Helper function to treat null status as active (open)
export function getProjectStatus(status: string | null | undefined): ProjectStatus {
  if (!status) return "active";
  // Treat 'open' as 'active' for backwards compatibility
  if (status === "open") return "active";
  return status as ProjectStatus;
}

export function isProjectOpen(status: string | null | undefined): boolean {
  return getProjectStatus(status) === "active";
}

export function isProjectClosed(status: string | null | undefined): boolean {
  return getProjectStatus(status) === "closed";
}
